import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AppModules } from '@common-modules/shared/app-modules.enum';
import Color from 'color';

const COMPONENT_SELECTOR = 'wlm-water-balance-item-input';

@Component({
    selector: COMPONENT_SELECTOR,
    templateUrl: './water-balance-item-input.component.html',
    styleUrl: './water-balance-item-input.component.scss',
    standalone: false
})
export class WaterBalanceItemInputComponent {
  @Input() className: string;
  @Input() inputPosition: string;
  @Input() i18Key: string;
  @Input() color: string;
  @Output() colorChange = new EventEmitter<string>();

  T_SCOPE = `${AppModules.WaterBalance}.kpis`;

  formControl: FormControl = new FormControl();

  onColorPickerChange(color: string): void {
    const formattedColor = this.mapToOutputAcceptedFormat(color);
    this.formControl.setValue(formattedColor);
    this.formControl.markAsDirty();
    this.color = formattedColor;
    this.colorChange.emit(this.color);
  }

  mapToOutputAcceptedFormat = (color: string): string => {
    let colorObject = new Color(color);
    const convertedColor = colorObject.hexa();
    return convertedColor;
  };
}
